import { ErrorOverlay } from "../overlay/ErrorOverlay";
import posthog from "posthog-js";
import { useAppStore } from "@/hooks/useAppStore";
import { useRouteError } from "react-router-dom";
import { useEffect } from "react";

export const ErrorBoundary = () => { 
  const error = useRouteError();
  useEffect(() => {
    if (!error) return;
    const roomId = useAppStore.getState().roomId;
    const user = useAppStore.getState().user;
    posthog.captureException(error, {
      roomId: roomId || "no_room",
      userId: user?.userId || "anonymous",
      appId: user?.appId || "no_app",
      platform: user?.platform || "unknown",
      provider: user?.provider || "unknown",
    });
  }, [error]);
  return <ErrorOverlay />;
};
